import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormsModule } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService, GlobalService, PesquisaSatisfacaoService, StorageService } from '@app/services';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { exit } from 'process';


@Component({
  selector: 'app-resposta',
  templateUrl: './resposta.component.html',
  styleUrls: ['./resposta.component.scss'],
  providers: [MessageService]
})
export class RespostaComponent implements OnInit {
  pipe = new DatePipe('en-US'); 
  formResposta: FormGroup;

  dataAtendimentoTratada: String;
  horaAtendimentoTratada: String;

  exibeBotao: Boolean = false;

  solicitacao: any;
  perguntas: any;
  respostas = new Map();
  rating: any;

  perguntaRespostaMap = new Map();

  constructor(
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private pesquisaSatisfacaoService: PesquisaSatisfacaoService,
    private serviceStorage: StorageService,
    private serviceGlobal: GlobalService,
    private confirmationService: ConfirmationService,
  ) { 
  }

  ngOnInit(): void {
    this.spinner.show();
    this.exibeBotao = false;
    this.route.queryParams
      .subscribe((params) => {
        try {
          this.pesquisaSatisfacaoService
            .getSolicitacaoPorId(params.solicitacao)
            .then((retorno:any) => 
            {
              if (retorno.sucesso == false)
              {
                this.fecharJanelaErro(retorno.mensagem);
              }
              else
              {
                this.solicitacao = retorno.objeto;
                if (this.solicitacao.matriculaAluno != this.serviceStorage.getAccess().usuario.matricula)
                {
                  this.fecharJanelaErro("Essa solicitação não pertence ao aluno logado.\nFavor entrar novamente no Portal do Aluno.");
                }

                if (this.solicitacao.status != 1) 
                {
                  this.serviceGlobal.exibirAlerta("warn","Essa Experiência já foi avalidada",null);
                  this.router.navigateByUrl("/solicitacao");
                }
                
                this.solicitacao.pesquisaSatisfacao.perguntas.forEach(p => {
                  if (p.inativa == false){
                    this.respostas.set(p.id,{valor:""});
                  }
                });
                this.perguntas = this.solicitacao.pesquisaSatisfacao.perguntas;
              }
              this.spinner.hide();
            });
        }
        catch (error) 
        {
          this.fecharJanelaErro("Erro ao recuperar dados da solicitação.\nFavor entrar novamente no Portal do Aluno.");
          this.spinner.hide();
        }
      });
      console.log("respostas");
      console.log(this.respostas);
  }

  onSubmit() {
    console.log("onsubmit");
    this.spinner.show();

    let body = new Array();
    this.respostas.forEach((value: any, key: any) => 
    {
      let id = null;
      let texto = null;
      if (value.id != undefined){
        id = value.id;
      }
      else if (value.valor != "")
      {
        texto = value.valor;
      }
      body.push({
        solicitacao:{id:this.solicitacao.id},
        pergunta:{id:key},
        opcaoResposta:{id:id},
        respostaTexto: texto,
      });
    });

    this.pesquisaSatisfacaoService.salvarRespostas(body)
      .then((retornoDTO:any) => {
        this.spinner.hide();
        if (retornoDTO.sucesso)
        {
          this.serviceGlobal.exibirAlerta(
            'success',
            retornoDTO.mensagem,
            null
          );
        }
        else
        {
          this.serviceGlobal.exibirAlerta(
            'warn',
            retornoDTO.mensagem,
            null
          );
        }
        this.router.navigateByUrl("/solicitacao")
      });
    this.spinner.hide();
  }

  refreshParent() {
    window.opener.location.reload();
  }

  setResposta(pergunta, event)
  {
    console.log("setResposta");
    console.log(pergunta);
    console.log(event);
    let resp = null;
    let habilitaBotao = true;
    if (pergunta.tipoResposta.descricao == '5 ESTRELAS')
    {
      resp = pergunta.opcoesResposta.find(r => r.valor == event);
    }
    else if (pergunta.tipoResposta.descricao == 'SIM/NÃO')
    {
      resp = pergunta.opcoesResposta.find(r => r.valor == event);
    }
    else if (pergunta.tipoResposta.descricao == 'AVALIAÇÃO 10')
    {
      resp = pergunta.opcoesResposta.find(r => r.valor == event.value);
    } 
    else if (pergunta.tipoResposta.descricao == 'ATENDIMENTO')
    {
      resp = pergunta.opcoesResposta.find(r => r.valor == event);
    } 
    else if (pergunta.tipoResposta.descricao == 'TEXTO')
    {
      resp = this.respostas.get(pergunta.id);
      resp.valor = event;
      if (resp.valor == "")
      {
          habilitaBotao = false;
      }
    } 
    else
    {
      resp = event.value
    }
    console.log(resp);
    this.respostas.set(pergunta.id, resp);
    this.habilitarBotao(habilitaBotao);
  }

  getLabel(idPergunta, value):any
  {
    return this.perguntas.find(p => p.id == idPergunta).opcoesResposta.find(r => r.valor == value).descricao;
  }

  habilitarBotao(force:boolean)
  {
    let valor = force;
    if (!force)
    {
      this.respostas.forEach((value: any, key: any) => {
        if (value.valor != null && value.valor != "")
        {
          valor = true;
        }
      });  
    }
    this.exibeBotao = valor;
  }

  fecharJanelaErro(mensagem) {
    alert(mensagem);
    window.close();
  }

  minhasSolicitacoesPendentes() {
    this.router.navigateByUrl("/solicitacao");
  }

  naoQueroResponder(event) {
    event.preventDefault();
    //console.log(event);
    this.confirmationService.confirm({
      message: 'Essa avaliação não poderá ser avaliada no futuro. Deseja continuar?',
      header: 'Confirmação',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.spinner.show();
        this.pesquisaSatisfacaoService
          .naoResponder(this.solicitacao)
          .then((retorno:any) => {
            this.spinner.hide();
            if (retorno.sucesso)
            {
              this.serviceGlobal.exibirAlerta(
                'success',
                retorno.mensagem,
                null
              );
            }
            else
            {
              this.serviceGlobal.exibirAlerta(
                'warn',
                retorno.mensagem,
                null
              );
            }
            this.router.navigateByUrl("/solicitacao");
          });
      },
    });
  }
}
